import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

const PageActResearchEmergencyInitizializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={{}}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageActResearchEmergencyInitizializer.displayName =
  'Act Research Emergency Initizializer component';

export default PageActResearchEmergencyInitizializer;
